export default {"src":"https://cdn.jetlend.ru/_next/static/media/chevron-down.0b368bf9.svg","height":11,"width":18,"blurWidth":0,"blurHeight":0};